import {makeAutoObservable} from 'mobx';
import {storage} from '@utils/tools';

class Store {
  deal = null;

  constructor() {
    makeAutoObservable(this);
  }

  setDeal(data) {
    this.deal = data;
    storage.set('deal', data);
  }

  resetDeal() {
    this.deal = null;
    storage.remove('deal');
  }
}

export default new Store();
